<div class="page-content">
    <p-panel header="Jobs - {{ jobType | titlecase }}" class="no-x-padding">
        <p-tabs value="instances">
            <p-tablist>
                <p-tab value="instances">Instances</p-tab>
                @if (jobType === 'action') {
                    <p-tab value="specifications">Specifications</p-tab>
                }
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel value="instances">
                    <app-jobs-instance-crud></app-jobs-instance-crud>
                </p-tabpanel>

                @if (jobType === 'action') {
                    <p-tabpanel value="specifications">
                        @if (showLoading) {
                            <div style="text-align: center">
                                <p-progressSpinner
                                    styleClass="w-4rem h-4rem"
                                    strokeWidth="4"
                                    animationDuration="1.5s"
                                ></p-progressSpinner>
                                <div class="mt-2 mb-2">
                                    {{ loadingStr }}
                                </div>
                            </div>
                        }
                        <div [style.display]="!showLoading ? 'block' : 'none'">
                            <div class="hcol-flex">
                                <div class="hcol-100">
                                    <p-select
                                        [options]="specificationsOptions"
                                        [(ngModel)]="selectedSpeficiationUUID"
                                        optionLabel="label"
                                        optionValue="key"
                                        placeholder="Select a specficiation"
                                        (onChange)="onSelectedSpecificationChanged()"
                                        appendTo="body"
                                    >
                                        <ng-template let-spec #item>
                                            <div
                                                class="monospace"
                                                [ngStyle]="{'font-weight': spec.active ? 'bold' : 'normal'}"
                                            >
                                                {{ spec.label }}
                                            </div>
                                        </ng-template>
                                    </p-select>
                                </div>
                                <div style="width: 10rem">
                                    <p-button
                                        label="Set active"
                                        [fluid]="true"
                                        [disabled]="!selectedSpeficiationUUID || (selectedSpeficiation?.active ?? true)"
                                        (onClick)="setActiveSpecification()"
                                    />
                                </div>
                            </div>
                            <div class="mt-2" style="min-height: 10rem">
                                @if (selectedSpeficiation) {
                                    <app-generic-tree
                                        [data]="specificationAppDetailsItems"
                                        [cols]="specificationColumns"
                                        dataKey="id"
                                        [showColumnToggle]="false"
                                        [showNewButton]="false"
                                        [showRefreshButton]="false"
                                        entityName="Plugin"
                                        [flexHeight]="true"
                                    >
                                    </app-generic-tree>
                                } @else {
                                    <p-message severity="warn">Please select a specification.</p-message>
                                }
                            </div>
                        </div>
                    </p-tabpanel>
                }
            </p-tabpanels>
        </p-tabs>
    </p-panel>
</div>
